<template>
  <div>
    <SignIn/>
  </div>
</template>

<script>
  import SignIn from "../components/SingIn.vue";
  export default {
    name: 'SignInView',
    components: {
      SignIn
    }
  }
</script>